/**
 * Created by nemio on 27.11.2015.
 */
import en_US from '../../en_US';

const extend = {
  tv: 'Channels',
  watch_now: 'Watch Now',
  on_demand: 'On Demand',
  on_now: 'TV Guide',
  featured: 'Featured',
  page: {
    ...en_US.page,
    epg: 'TV Guide'
  }
};

const en_RC = {...en_US, ...extend};

export default en_RC;



// WEBPACK FOOTER //
// ./src/locales/dics/ext/rc/en_RC.js